import { render } from "./TaskHost.vue?vue&type=template&id=2acfd3ff&scoped=true"
import script from "./TaskHost.vue?vue&type=script&lang=js"
export * from "./TaskHost.vue?vue&type=script&lang=js"

import "./TaskHost.vue?vue&type=style&index=0&id=2acfd3ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acfd3ff"]])

export default __exports__